import { SVGProps } from 'react';

export const TableOrderArrow = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.12373 0.593628C3.50363 -0.0972744 4.49637 -0.0972741 4.87627 0.593629L7.51534 5.39318C7.88179 6.05963 7.39962 6.875 6.63907 6.875H1.36093C0.600379 6.875 0.118211 6.05963 0.484664 5.39318L3.12373 0.593628Z"
        fill="currentColor"
      />
    </svg>
  );
};
